import Lookup from './lookup.js';

export default class Role extends Lookup
{
    constructor(id, name, title, permissions, created_at, updated_at) {
        super(id, name, title, created_at, updated_at);
        
        this.permissions = [];
    }

    setPermissions(permissions) {
        this.permissions = permissions;
        return this;
    }

}
